module.exports = __webpack_public_path__ + "img/Enmascarar grupo 20@2x.f7a2ded2.png";